export const environment = {
  production: false,
  apiUrl:
    "https://agent-gateway.carepoint-dev-app.prj.gcp.wellsky.io/api/v1/dashboard",
  features: {
    useMockApi: false,
    enableLogs: true,
    enableDistributedTracing: false,
  },
  okta: {
    issuer: "https://wellsky.okta.com",
    clientId: "0oauoh9jt08p6Fiy21d7",
  },
};
